import { render, staticRenderFns } from "./promocion-prevencion-hub.vue?vue&type=template&id=7b4856ca&"
import script from "./promocion-prevencion-hub.vue?vue&type=script&lang=js&"
export * from "./promocion-prevencion-hub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports